import './App.css';
import './styles/tokens.css';
import './styles/responsive-mobile.css';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import TurneroPage from './pages/TurneroPage';
import PacientesPage from './pages/PacientesPage';
import PacienteSubview from './pages/PacienteSubview';
import ProfesionalesPage from './pages/ProfesionalesPage';
import FinanzasPage from './pages/FinanzasPage';
import ProfesionalPrestacionesPage from './pages/ProfesionalPrestacionesPage';
import ConfiguracionPage from './pages/ConfiguracionPage';

// --- Portal Paciente ---
import PacienteProtectedRoute from './components/paciente/PacienteProtectedRoute';
import PacienteLoginPage from './pages/paciente/PacienteLoginPage';
import PacienteCambiarPasswordPage from './pages/paciente/PacienteCambiarPasswordPage';
import PacienteDashboard from './pages/paciente/PacienteDashboard';
import PacienteHistoriaClinicaPage from './pages/paciente/PacienteHistoriaClinicaPage';
import PacienteTurnosPage from './pages/paciente/PacienteTurnosPage';
import PacienteDatosPage from './pages/paciente/PacienteDatosPage';
import ReservarTurnoPage from './pages/ReservarTurnoPage';

import { useClient } from './services/ClientContext';

function App() {
  const { modulos } = useClient();

  return (
    <BrowserRouter>
      <div className="app-container">
        <Routes>
          {/* Rutas públicas profesionales */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reservar" element={<ReservarTurnoPage />} />

          {/* Portal Paciente - rutas públicas */}
          <Route path="/paciente/login" element={<PacienteLoginPage />} />
          <Route path="/paciente/cambiar-password" element={<PacienteCambiarPasswordPage />} />

          {/* Portal Paciente - rutas protegidas */}
          <Route element={<PacienteProtectedRoute />}>
            <Route path="/paciente" element={<PacienteDashboard />} />
            <Route path="/paciente/historia-clinica" element={<PacienteHistoriaClinicaPage />} />
            <Route path="/paciente/turnos" element={<PacienteTurnosPage />} />
            <Route path="/paciente/datos" element={<PacienteDatosPage />} />
          </Route>

          {/* Rutas protegidas profesionales */}
          <Route element={<ProtectedRoute />}>
            {modulos.calendario && <Route path="/" element={<TurneroPage />} />}
            {modulos.pacientes && (
              <>
                <Route path="/pacientes" element={<PacientesPage />} />
                <Route path="/pacientes/:id" element={<Navigate to="/pacientes" replace />} />
                <Route path="/pacientes/:id/:viewType" element={<PacienteSubview />} />
              </>
            )}
            {modulos.profesionales && (
              <>
                <Route path="/profesionales" element={<ProfesionalesPage />} />
                <Route path="/profesionales/:id/prestaciones" element={<ProfesionalPrestacionesPage />} />
              </>
            )}
            {modulos.finanzas && <Route path="/finanzas" element={<FinanzasPage />} />}

            {modulos.pacientes && <Route path="/rp" element={<Navigate to="/pacientes" replace />} />}
            {modulos.profesionales && (
              <Route path="/prestaciones" element={<Navigate to="/profesionales" replace />} />
            )}
            {modulos.configuracion && <Route path="/configuracion" element={<ConfiguracionPage />} />}
          </Route>

          {/* Cualquier ruta no encontrada redirige al inicio */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
